import format from 'date-fns/format';
import toDate from 'date-fns/toDate';
import { DateFormat } from 'src/constants/dateTimeFormatOption';

export const transformDateHelper = (
  date: string | Date | null | undefined,
  dateFormat: string = DateFormat.MONTH_DAY_YEAR,
  // @ts-ignore
): string => (date ? format(toDate(new Date(date)), dateFormat) : '');
